import { Drawer } from '../domain';


export const isBoxOnly = (drawer: Drawer): boolean => {
    return drawer.scoop || drawer.panel == null || drawer.panel.style == null;
}
